import React, {useState} from 'react';
import ContentModule from './components/content-module.js';
import Portfolio from './components/portfolio.js';
import './App.css';
import {TerminalWindow} from './components/terminal-window.js';

function App() {
  
  const [page, setPage] = useState('home');
  
  return (
    <div className="App">
    
      <TerminalWindow />
      
      <ContentModule page={page} setPage={setPage} />
      
      <div className="outer-portfolio-container">
        <div id="inner-portfolio-container">
          <Portfolio page={page} setPage={setPage} />
        </div>
      </div>
      
      <div className="site-credit" id="site-credit">
        <p>© Daniel Whiteside, 2026</p>
        <p>Built with React · Hosted on DigitalOcean · <a href="https://github.com/whiteside-daniel/katyusha.git" target="_blank" rel="noreferrer">Source</a></p>
      </div>
      
    </div>
  );
}

export default App;
